<mat-form-field class="text-field" appearance="fill">
    <mat-date-range-input class="dateRange"  [formGroup]="datesFormGroup" [rangePicker]="picker" [min]="minDate" (click)="picker.open()">
      <input matStartDate formControlName="startDate" placeholder="Start date" [readonly]="true" [matTooltip]="datesFormGroup.get('startDate').value"  #startDateInput>
      <input matEndDate formControlName="endDate" placeholder="End date" [readonly]="true" [matTooltip]="datesFormGroup.get('endDate').value" #endDateInput>
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle >
    <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
